module.exports = __webpack_public_path__ + "img/down-arrow-white.163dbed6.svg";